/**
 * dev  : wangqinfei
 * desc : 说明: 医生评价
 * props:
 * emit : setEvaluateFlag
 * slot :
 */
<template>
  <section class='g-evaluate-layout'>
    <div class="evaluate-title">对医生还满意吗？</div>
    <div class="evaluate-tip">您的评价会让医生做的更好</div>
    <div class="rate-box">
      <van-rate
        :value="rateValue"
        :size="30"
        :gutter="20"
        color="#01B956"
        @change="onChangeRate"
      />
    </div>
    <div class="rate-tip">{{ rateValue | filter_setRateTip}}</div>
    <div class="evaluate-btn">
      <van-button type="default" :loading="evaluateLoading" @click="handleEvaluate" :class="['evaluate-submit', rateValue ? '' : 'evaluate-submit-def']">提交</van-button>
    </div>
  </section>
</template>

<script>
import { getCookie } from '@/utils/auth'
import { toast } from '@/components/Toast'
import { saveRatingStar } from '@/api/index'
let organSign = getCookie('native_organSign')
export default {
  name: '',
  props: {},
  data() { 
    return {
      rateValue: 0,
      evaluateLoading: false
    } 
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    onChangeRate(val) {
      this.rateValue = val
    },
    async handleEvaluate() {
      if (!this.rateValue) return
      let inquiryRecordGuid = this.$store.getters.inquiryRecordGuid
      const data = {
        bizId: inquiryRecordGuid,
        drugstoreId: organSign,
        star: this.rateValue
      }
      console.log('handleEvaluate data:', data)
      try {
        this.evaluateLoading = true
        const res = await saveRatingStar(data)
        this.evaluateLoading = false
        if (res.code === 0) {
          this.$emit("setEvaluateFlag")
          toast('感谢您的反馈！')
        } else {
          toast(res.msg)
        }
      } catch (err) {
        this.evaluateLoading = false
        toast('保存评价失败！')
      }
    }
  },
  filters: {
    filter_setRateTip(rateValue) {
      let result = ''
      switch (rateValue) {
        case 1:
          result = '非常不满意'
          break;
        case 2:
          result = '不满意'
          break;
        case 3:
          result = '一般'
          break;
        case 4:
          result = '满意'
          break;
        case 5:
          result = '非常满意'
          break;
        default:
          break;
      }
      return result
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.g-evaluate-layout {
  height: 189px;
  margin: 15px 15px 5px;
  background: #fff;
  border-radius: 14px;
  text-align: center;
  position: relative;
  .evaluate-title {
    font-size: 16px;
    font-weight: 500;
    color: #292626;
    line-height: 22px;
    padding-top: 15px;
  }
  .evaluate-tip {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 20px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .rate-box {
    line-height: 20px;
  }
  .rate-tip {
    font-size: 12px;
    font-weight: 400;
    color: #333;
    line-height: 16px;
    margin: 10px auto;
  }
  .evaluate-btn {
    width: 100%;
    height: 44px;
    border-top: 0.02667rem solid #f7f7f7;
    position: absolute;
    bottom: 0;
    line-height: 44px;
    .evaluate-submit {
      width: 260px;
      height: 44px;
      font-size: 17px;
      color: #01B956;
      border-style: none;
      border-radius: 25px;   
      position: absolute;
      margin-left: -130px; 
    }
    .evaluate-submit-def {
      color: #ccc;
    }
  }
}
</style>
